import React, {} from "react"
import {useParams, useNavigate, useLocation, useSearchParams,} from "react-router-dom";
const withRouter = (WrappedComponent) => (props) => {
   const params = useParams();
   const location = useLocation();
   const hash = location.hash;
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const current_page_view = searchParams.get("page");
   const collection_id = searchParams.get("id");
   const open_collection = searchParams.get("open_collection");

   return (
      <WrappedComponent
         {...props}
         params={params}
         navigate={navigate}
         location={location}
         searchParams={searchParams}
         current_page_view={current_page_view}
         collection_id={collection_id}
         open_collection={open_collection}
         hash={hash}
      />
   );
};

export { withRouter };